import Bugsnag from '@bugsnag/js';

if (import.meta.env.VITE_BUGSNAG_API_KEY) {
    // eslint-disable-next-line no-undef
    const userConfig = config.user;

    Bugsnag.start({
        apiKey: import.meta.env.VITE_BUGSNAG_API_KEY,
        enabledReleaseStages: ['production', 'staging'],
        releaseStage: import.meta.env.VITE_APP_ENV ?? 'development',
        metadata: {
            user: {
                user_id: userConfig?.id,
                language_id: userConfig?.language.id,
            },
        },
    });
}
